import { Container, IDestroyOptions, Resource, Sprite, Texture } from "pixi.js";
import { MyWalletsBoxElementType } from "./MyWalletsBoxElementType";
import { Event } from "event-system";
import gsap from "gsap";

export class MyWalletsBoxElement extends Container {
    private static readonly SIDE_SIZE = 76;
    private static readonly SWITCH_TIME = 0.2;

    private readonly animation: gsap.core.Timeline;
    private readonly walletIcon: Sprite;
    private readonly glow: Sprite;

    public readonly onClick: Event<MyWalletsBoxElement>;
    public readonly data: WalletsBoxElementData;

    public set selected(selected: boolean) {
        this.glow.visible = selected;
        this.animation.fromTo(this.glow, { alpha: selected ? 0 : 1 }, { alpha: selected ? 1 : 0, duration: MyWalletsBoxElement.SWITCH_TIME, ease: 'power1.inOut' });
        this.animation.play();
        this.animation.then(() => {
            this.animation.clear();
        });
    }

    public constructor(walletTexture: Texture<Resource>, glowWexture: Texture<Resource>, data: WalletsBoxElementData) {
        super();
        this.data = data;
        this.animation = new gsap.core.Timeline({ paused: true });
        this.onClick = new Event();
        this.walletIcon = new Sprite(walletTexture);
        this.walletIcon.width = this.walletIcon.height = MyWalletsBoxElement.SIDE_SIZE;
        this.walletIcon.on('pointerup', this.onClickHandle, this);
        this.walletIcon.eventMode = 'static';
        this.glow = new Sprite(glowWexture);
        this.glow.width = this.glow.height = 210;
        this.glow.position.set(-(this.glow.width - this.walletIcon.width) * 0.5, -(this.glow.height - this.walletIcon.height) * 0.5);
        this.glow.visible = false;
        this.glow.eventMode = "none";
        this.glow.alpha = 0;
        this.addChild(this.glow, this.walletIcon);
    }

    private onClickHandle(): void {
        this.onClick.emit(this);
    }

    public override destroy(options?: boolean | IDestroyOptions): void {
        this.walletIcon.off('pointerup', this.onClickHandle, this);
        this.animation.kill();
        super.destroy(options);
    }
}

export type WalletsBoxElementData = {
    type: MyWalletsBoxElementType;
    walletAddress?: string;
    networkType?: string;
}
